/**
 * Хуучин flat path-уудыг scoped URL руу redirect хийдэг helper.
 * `/dashboard`, `/items.html` гэх зэрэг URL-ыг (хэрэв localStorage-д
 * `tsetsu.tenantId`/`companyId` бичигдсэн бол) `/:tenantId/:companyId/<page>`
 * руу шилжүүлнэ. Cache байхгүй бол `/select-scope` (auth-тай) эсвэл `/login`.
 */
import { Navigate, useLocation } from 'react-router-dom';
import {
  buildScopedPath,
  isLikelyGuid,
  publicRoutes,
  type ScopedRouteKey,
} from './routes';
import { getAuth, hasToken } from '@/shared/auth/storage';

interface Props {
  to: ScopedRouteKey;
  /** `?id=...` гэх мэт query string-ийг preserve хийнэ. */
  preserveQuery?: boolean;
}

export function LegacyRedirect({ to, preserveQuery = true }: Props) {
  const loc = useLocation();
  if (!hasToken()) {
    return <Navigate to={publicRoutes.login} replace state={{ from: loc.pathname + loc.search }} />;
  }
  const tenantId = getAuth('tsetsu.tenantId');
  const companyId = getAuth('tsetsu.companyId');
  if (!isLikelyGuid(tenantId) || !isLikelyGuid(companyId)) {
    return (
      <Navigate
        to={publicRoutes.selectScope}
        replace
        state={{ from: loc.pathname + loc.search }}
      />
    );
  }
  const search = preserveQuery ? loc.search : '';
  const target = buildScopedPath(to, { tenantId, companyId }) + search;
  return <Navigate to={target} replace />;
}
